import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ModalBody } from 'reactstrap';
import { stateAccount } from '../../../assets';

const SecondStepInvoiceDate = () => {
  const { t } = useTranslation();

  return (
    <ModalBody className="px-2">
      <img
        src={stateAccount}
        alt="state-account"
        className="max-w-[200px] mx-auto mb-4"
      />
      <Box className="flex flex-shrink-0 items-center justify-center rounded-t-md text-center">
        <Typography variant="h6" className="!mt-5">
          {t('haveGeneratedReceipts')}
        </Typography>
      </Box>
      <Box className="md:w-10/12 w-full mx-auto">
        <Box className="bg-[#f5f9fc] my-[15px] mx-auto p-5 text-center">
          <Typography variant="body1">{t('theReceiptsSentMail')}</Typography>
        </Box>
      </Box>
    </ModalBody>
  );
};

export default SecondStepInvoiceDate;
